import React from "react";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { yyyymmddGenerator } from "../Analytics/AnalyticsUtils/yyyymmddGenerator";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useAppStore } from "../../../appStore";
import { enUS, enGB } from "date-fns/locale";
import { alertsFilterDateControlSx } from "./AlertsUtils/alertsFilterBar";

export const isCurrentDate = (selectedDate: string): boolean => {
  const currentDate = new Date();
  const formattedCurrentDate = currentDate.toDateString(); // Get the current date without time

  const selectedDateObj = new Date(selectedDate);
  const formattedSelectedDate = selectedDateObj.toDateString(); // Get the selected date without time

  return formattedSelectedDate === formattedCurrentDate;
};

export const EndDateDropDownAlerts = ({
  userFilters,
  setUserFilters,
  siteOptions,
  setTimeFiltersDisabled,
  warningIssued,
  setWarningIssued,
}: {
  userFilters: any;
  setUserFilters: Dispatcher<any>;
  siteOptions: any;
  setTimeFiltersDisabled: Dispatcher<boolean>;
  warningIssued: boolean;
  setWarningIssued: Dispatcher<boolean>;
}) => {
  const parentAccounts = JSON.parse(
    localStorage?.getItem?.("parentAccounts") ?? "[]"
  );

  const siteIds = new Map();
  siteOptions.forEach((object: any) => {
    siteIds.set(object.name, object.id);
  });

  const parentIds = new Map();
  parentAccounts.forEach((object: any) => {
    parentIds.set(object.name, object.id);
  });

  const [endTimeAnchorEl, setEndTimeAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const endTimeOpen = Boolean(endTimeAnchorEl);
  const handleEndTimeClick = (event: React.MouseEvent<HTMLElement>) => {
    // event.stopPropagation(); // Stop event propagation to prevent table sorting
    setEndTimeAnchorEl(event.currentTarget);
  };
  const handleEndTimeClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation(); // Stop event propagation to prevent table sorting
    setEndTimeAnchorEl(null);
  };

  const { dateMMDDYYYY, setDateMMDDYYYY } = useAppStore();

  const selectedLocale = dateMMDDYYYY ? enUS : enGB;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={selectedLocale}
    >
      <div className="w-full">
      <DatePicker
        label={
          userFilters.end_date ? (
            <div className="flex">
              <>{`End Date`}</>
              <div>
                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-controls={endTimeOpen ? "long-menu" : undefined}
                  aria-expanded={endTimeOpen ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleEndTimeClick}
                  sx={{
                    marginLeft: "5px",
                    padding: 0,
                    color: "#000000",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    "aria-labelledby": "long-button",
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  anchorEl={endTimeAnchorEl}
                  open={endTimeOpen}
                  onClose={handleEndTimeClose}
                  slotProps={{
                    paper: {
                      style: {
                        maxHeight: 48 * 4.5,
                        width: "20ch",
                      },
                    },
                  }}
                >
                  <MenuItem
                    key="mm-dd-yyyy-end"
                    onClick={(event) => {
                      setDateMMDDYYYY(true);
                      handleEndTimeClose(event);
                    }}
                  >
                    MM/DD/YYYY
                  </MenuItem>
                  <MenuItem
                    key="dd-mm-yyyy-end"
                    onClick={(event) => {
                      setDateMMDDYYYY(false);
                      handleEndTimeClose(event);
                    }}
                  >
                    DD/MM/YYYY
                  </MenuItem>
                </Menu>
              </div>
            </div>
          ) : (
            <>End Date</>
          )
        }
        value={userFilters.end_date}
        onChange={(newValue: any) => {
          if (!warningIssued && !isCurrentDate(newValue)) {
            alert(
              `Selecting any dates for start date or end date which are not the current date will prevent new alerts from being refreshed in the background`
            );
            setWarningIssued(true);
          }
          if (newValue !== null) {
            if (userFilters.start_date && newValue < userFilters.start_date) {
              alert("End date cannot be before start date");
              return;
            }
            setUserFilters((previousState: any) => ({
              ...previousState,
              end_date: newValue,
            }));
          }
          if (newValue === null) {
            setTimeFiltersDisabled(true);
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                end_date: null,
                start_time: null,
                end_time: null,
              };
            });
          }
          if (
            yyyymmddGenerator(newValue) !==
            yyyymmddGenerator(userFilters.start_date)
          ) {
            setTimeFiltersDisabled(true);
            setUserFilters((previousState: any) => {
              return { ...previousState, start_time: null, end_time: null };
            });
          }
          if (
            yyyymmddGenerator(newValue) ===
            yyyymmddGenerator(userFilters.start_date)
          ) {
            setTimeFiltersDisabled(false);
          }
        }}
        renderInput={(params) => (
          <TextField
            size="small"
            {...params}
            inputProps={{ ...params.inputProps, autoComplete: "off" }}
            sx={alertsFilterDateControlSx}
          />
        )}
      />
      </div>
    </LocalizationProvider>
  );
};
